export const logout = async (): Promise<boolean> => {
  const result = await fetch('/api/v1/auth/logout', {
    method: 'POST',
  })

  if (result.ok) {
    return true
  }
}
